import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { refundP24Transaction } from "../../actions/p24TransactionActions";

import { parseMoneyMultiply100, parseMoneyDiv100 } from "../../helpers/utils"

const floatRegExp = new RegExp('([0-9]+)$')



class P24TransactionRefundForm extends React.Component {

    state = {
        //model zwrotu transakcji
        transactionRefund: {
            amount: parseMoneyDiv100(this.props.transaction.amount - this.props.transaction.refundTotalAmount),
            description: 'Zwrot: ' + this.props.transaction.description
        }
    }

    componentDidMount() {
      
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        //parsujemy kwote do groszy
        let transactionRefundConverted = { ...this.state.transactionRefund, amount: parseMoneyMultiply100(this.state.transactionRefund.amount) }

        //musimy zrobic w try/catch - bo dalej nie przejdzie - konczy sie dzialanie w tej metodzie
        try {
            await this.props.refundP24Transaction(this.props.transaction.id, transactionRefundConverted);
        } catch (error) {
            console.log('blad - ale idziemy dalej')
        }

        this.props.onSubmit();

    };

    handleInputChange = e => {
        const target = e.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        let transactionRefund = { ...this.state.transactionRefund, [name]: value };
        this.setState({ transactionRefund });
    };



    handleDecimalInputChange = e => {
        const target = e.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        //nie pozwalamy na pusty string
        //value === '' ||
        if (floatRegExp.test(value)) {
            //przechodzi walidacje regex

            let transactionRefund = { ...this.state.transactionRefund, [name]: value };

            this.setState({ transactionRefund });
        }
    }

    handleCancel = e => {
        this.props.onCancel();
    };

    render() {



        return (
            <div className="w3-card-4" >
                <div className="w3-container w3-theme">
                    <h2 className="w3-center">
                        <FormattedMessage
                            id="app.p24TransactionRefundForm.title"
                            defaultMessage="Return transaction"
                        />
                    </h2>
                </div>


                <div className="w3-row-padding">

                    <div className="w3-col s4">
                        <input
                            className="w3-input w3-right-align"
                            type="text"
                            name="amount"
                            onChange={this.handleDecimalInputChange}
                            value={this.state.transactionRefund.amount}
                            maxLength="10"
                        />
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Transaction.amount"
                                defaultMessage="Amount"
                            />
                        </label>
                    </div>
                    <div className="w3-col s2">
                        <input
                            className="w3-input w3-border-0"
                            type="text"
                            name="currency"
                            onChange={this.handleInputChange}
                            value="PLN"
                            readOnly
                        ></input>
                    </div>
                </div>

                <div className="w3-row-padding">
                    <div className="w3-col s6">
                        <input
                            className="w3-input"
                            type="text"
                            name="description"
                            onChange={this.handleInputChange}
                            value={this.state.transactionRefund.description}
                        />
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Transaction.description"
                                defaultMessage="Description"
                            />
                        </label>
                    </div>
                </div>


                <form className="w3-container" onSubmit={this.handleSubmit}>

                    <div className="w3-bar">
                        <button
                            className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                            type="submit"
                        >
                            <FormattedMessage
                                id="app.p24TransactionRefundForm.submit"
                                defaultMessage="submit"
                            />
                        </button>
                        <button
                            className="w3-btn w3-theme-light w3-bar-item w3-right w3-margin-right"
                            type="reset"
                            onClick={this.handleCancel}
                        >
                            <FormattedMessage
                                id="app.p24TransactionRefundForm.cancel"
                                defaultMessage="cancel"
                            />
                        </button>
                    </div>
                </form>
            </div>
        )
    }

}

P24TransactionRefundForm.propTypes = {
    //dane wejsciowe obiektu do wypelnienia
    transaction: PropTypes.object.isRequired,
    //akcja zwrotna na anuluj
    onCancel: PropTypes.func.isRequired,
    //akcja zwrotna na zatwierdzenie
    onSubmit: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    p24MerchantPaymentMethodList: state.p24MerchantReducer.p24MerchantPaymentMethodList
});

const mapDispatchToProps = ({
    refundP24Transaction: refundP24Transaction
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P24TransactionRefundForm);